/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, OnInit} from '@angular/core';
import {UIRouter} from '@uirouter/core';

import {FolderCopyModalComponent} from './folder-copy-modal.component';
import {AdminResourceCopyConfig} from '../common/controller/admin-resource-copy-config';
import {AdminResourceRouteContext, readAdminResourceRouteContext} from '../common/controller/admin-resource-route-context';

@Component({
  standalone: false,
  selector: 'adn-folder-context-route-page',
  template: `
    <adn-admin-resource-context-actions
      *ngIf="context"
      [model]="context.model"
      [modelComms]="context.modelComms"
      [isNew]="context.isNew"
      [readOnly]="context.readOnly"
      [copyConfig]="copyConfig">
    </adn-admin-resource-context-actions>
  `
})
export class FolderContextRoutePageComponent implements OnInit {
  context: AdminResourceRouteContext;

  readonly copyConfig: AdminResourceCopyConfig = {
    modalComponent: FolderCopyModalComponent,
    stateUrl: 'app.dat-seg.folders.folder',
    lcase: 'folder',
    ucase: 'Folder'
  };

  constructor(private readonly uiRouter: UIRouter) {
  }

  ngOnInit(): void {
    this.context = readAdminResourceRouteContext(this.uiRouter);
  }
}
